import { render, staticRenderFns } from "./TaxCategoryUpdate.vue?vue&type=template&id=3b93013e&"
import script from "./TaxCategoryUpdate.vue?vue&type=script&lang=js&"
export * from "./TaxCategoryUpdate.vue?vue&type=script&lang=js&"
import style0 from "./TaxCategoryUpdate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TaxCategoryUpdate.vue"
export default component.exports